import React, { useState } from 'react';

import {
  CancellationPolicyLink,
  CancellingInfo,
  CancellingInfoTitle
} from './CancellationInfo.styled';
import { CancellationPolicyModal } from 'screens/Book/components/CancellationPolicyModal';

const CANCELLATION_POLICY_TEXT =
  'If you are unable to make your appointment, please cancel within the designated timeframe as stated in our';
const CANCELLATION_POLICY_LINK = 'cancellation policy';
const CANCELLATION_POLICY_SUFFIX = 'Late cancellations or no-shows may be subject to a fee.';

export const CancellationInfo = () => {
  const [showCancellationPolicy, setShowCancellationPolicy] = useState(false);
  return (
    <CancellingInfo>
      <CancellingInfoTitle>Need to cancel?</CancellingInfoTitle>
      {CANCELLATION_POLICY_TEXT}{' '}
      <CancellationPolicyLink
        onClick={() => setShowCancellationPolicy(true)}
        text={CANCELLATION_POLICY_LINK}
      />
      . {CANCELLATION_POLICY_SUFFIX}
      <CancellationPolicyModal
        show={showCancellationPolicy}
        onClickClose={() => setShowCancellationPolicy(false)}
      />
    </CancellingInfo>
  );
};
